import { Component } from 'react';
import GameData from "../mobx/GameData";
import { observe } from "mobx";
import { Button, Card, Dropdown } from "react-bootstrap";

import './LevelTilesPage.scss';
import { ChrFile } from "../components/nes/ChrFile";
import { PalettePreview } from "../components/nes/PalettePreview";
import { getCollisionType } from "../data/CollisionType";
import ApplicationState from "../mobx/ApplicationState";

import { Col, Row, Container } from "react-bootstrap";

export default class LevelTilesPage extends Component {

    gameDataCleanup = null;

    constructor(props) {
        super(props);

        this.state = {
            gameTiles: JSON.parse(JSON.stringify(GameData.currentGame.tileData)),
            palettes: [
                GameData.currentGame.gamePaletteData.slice(0, 4),
                GameData.currentGame.gamePaletteData.slice(4, 8),
                GameData.currentGame.gamePaletteData.slice(8, 12),
                GameData.currentGame.gamePaletteData.slice(12, 16)
            ]
        };
        
    }

    componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceUpdate()
        });
        this.forceUpdate();
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    setPalette(tileId, paletteId) {
        const newGameTiles = Array.from(this.state.gameTiles);
        newGameTiles[tileId].palette = paletteId;
        this.setState({
            gameTiles: newGameTiles
        });
    }

    setCollision(tileId, collId) {
        const newGameTiles = Array.from(this.state.gameTiles);
        newGameTiles[tileId].collision = collId;
        this.setState({
            gameTiles: newGameTiles
        });
    }

    saveChanges() {
        GameData.replaceCurrentGame({
            ...GameData.currentGame,
            tileData: this.state.gameTiles
        });

        ApplicationState.addAlert('success', 'Tile changes have been saved!');
    }

    render() {
        return (
            <div className="tiles-page">
                <Container>
                    <Row>
                        <Col>


                                <h1>Map Tiles</h1>
                                <p className="mt-3">
                                    This page allows you to configure the tiles, or "blocks" available for use in your levels. You can configure their colors, and how 
                                    they respond to the player trying to pass through them, as well as which of your color palettes they use.
                                </p>
                                

                                <div className="mt-3">
                                    {this.state.gameTiles.map((tile, idx) => (
                                        <Card key={'game-tile-' + idx}>
                                            <Card.Body>
                                                <ChrFile isMeta={true} data={GameData.currentGame.gameGraphicsData} palette={this.state.palettes[tile.palette]} tileId={idx} />
                                                <div className="mb-1">
                                                    <table><tbody><tr><td>
                                                        Palette: 
                                                    </td>
                                                    <td>
                                                        <Dropdown className="palette-dropdown">
                                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id={"dd-palette-toggle" + idx}>
                                                                Palette {tile.palette + 1}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[0,1,2,3].map(paletteId => (
                                                                    <Dropdown.Item key={"pal-dd-option-" + idx + '-' + paletteId} onClick={() => this.setPalette(idx, paletteId)} className={tile.palette === paletteId ? 'active' : ''}>
                                                                        Palette {paletteId + 1}
                                                                        <PalettePreview palette={this.state.palettes[paletteId]} />
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td></tr></tbody></table>
                                                </div>
                                                <div className="mb-1">
                                                    <table><tbody><tr><td>
                                                        Collision:
                                                    </td>
                                                    <td>
                                                        <Dropdown className="collision-dropdown">
                                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id={"dd-collision-toggle" + idx}>
                                                                {getCollisionType(tile.collision)}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[0, 1, 3, 6, 2, 4, 5, 8, 9, 10, 7].map(collId => (
                                                                    <Dropdown.Item key={"coll-dd-option-" + idx + '-' + collId} onClick={() => this.setCollision(idx, collId)} className={tile.collision === collId ? 'active' : ''}>
                                                                        {getCollisionType(collId)}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td></tr></tbody></table>

                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                                <div className="button-footer-bar">
                                    <Button variant="primary" onClick={() => this.saveChanges()}>Save Changes</Button>
                                </div>

                            </Col>
                        </Row>
                    </Container>
            </div>
        );
    }
}